module.exports = __webpack_public_path__ + "img/Georgia.2c4e46e1.svg";